<template>
  <div class="form_usuario">
    <v-form ref="form" v-on:submit.prevent="" v-model="valid" lazy-validation>
      <v-container>
        <div v-if="create">
          <v-flex :class="[displayFlex]">
            <InputFile
              :component="'certificado'"
              :resetInput="this.resetInput"
              :prevIcon="'description'"
              :text="'Selecione um certificado'"
              @emitResetInput="emitResetInput($emit)"
              @getFile="getFile($event)"
            ></InputFile>
          </v-flex>
          <v-flex :class="[displayFlex]">
            <v-text-field
              v-model="cert.password"
              class="input-required"
              label="Senha:"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              validate-on-blur
              :rules="this.cert.file != undefined ? passRules : [v => true]"
              clearable
              :disabled="this.cert.file == undefined ? true : false"
              required
            ></v-text-field>
          </v-flex>
        </div>
        <v-layout row wrap v-if="create && !formEmp">
          <v-flex :class="displayFlex">
            <v-combobox
              v-model="select"
              :items="items"
              chips
              class="input-required"
              :rules="this.cert.file != undefined  ? passRules : [v => true]"
              label="Vincular a empresa: "
              item-text="empresa.razao"
              :multiple="true"
              item-value="_id"
              :disabled="this.cert.file == undefined ? true : false"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  close
                  class="v-chip--select-multi"
                  @input="remove(data.item)"
                >
                  <v-avatar
                    class="teal white--text"
                  >{{ data.item.empresa != undefined ? data.item.empresa.razao.slice(0, 1).toUpperCase() : ''}}</v-avatar>
                  {{ data.item.empresa != undefined ? data.item.empresa.razao : ''}}
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
        </v-layout>
        <v-layout v-if="vincular">
          <v-flex :class="displayFlex">
            <v-autocomplete
              v-model="certSelect"
              item-text="desc_venc"
              :items="arrayCert"
              label="Certificados:"
              color="teal"
              item-value="_id"
              clearable
              persistent-hint
              return-object
              @change="getSelected()"
              prepend-icon="description"
              no-data-text="Nenhum certificado cadastrado"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// import FormCertificado from "@/domain/conta/empresa/certificado/FormCertificado.js";
import InputFile from "@/components/shared/inputFile/InputFile.vue";
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService.js";
export default {
  props: [
    "displayFlex",
    "create",
    "vincular",
    "getDadosForm",
    "resetForm",
    "edit",
    "formEmp",
    "conta"
  ],
  components: {
    InputFile: InputFile
  },
  data() {
    return {
      cert: { file: undefined, password: "" },
      certSelect: "",
      arrayCert: [],
      valid: true,
      showPassword: false,
      menu0: false,
      show1: false,
      show2: false,
      show3: false,
      route: this.$router.history.current.path,
      passRules: [v => !!v || "Campo obrigatório"],
      select: "",
      items: [],
      resetInput: false
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getEmpresas();
      this.getCertificados();
    });
  },
  updated: function() {},
  watch: {
    resetForm: function(newV, oldV) {
      if (this.resetForm) {
        this.$refs.form.reset();
        if(this.cert){
          this.cert["file"] = undefined;
        }
        this.resetInput = true;
        this.$emit("changResetForm", false);
      }
    },
    getDadosForm: function(newV, oldV) {
      if (newV) {
        if (
          (this.formEmp && this.cert != undefined && this.cert.file != "") ||
          (this.$refs.form.validate() &&
            this.getDadosForm &&
            this.cert != undefined &&
            this.cert.file != "")
        ) {
          this.emitDadosForm();
        } else {
          this.$emit("emitDadosForm", false);
        }
      }
    }
  },
  computed: {
    certificate() {
      return this.$store.getters.certificate;
    }
  },
  methods: {
    getCertificados() {
      this.service = new CertificadoService(this.$http);
      this.service.getCertificadosConta(this.conta.conta).then(body => {
        let arrayEmpresas = body.items.concat(body.certs_not_owner)

        arrayEmpresas.forEach(item => {
          item["desc_venc"] = `${item.nome} - val.: ${new Date(
            item.validade
          ).toLocaleDateString()}`;
        });
        this.arrayCert = arrayEmpresas.slice();
      });
    },
    getEmpresas() {
      this.service = new EmpresaService(this.$http);
      this.service.getEmpresasConta(this.conta.conta).then(body => {
        this.items = body.empresas;
      });
    },
    getFile(file) {
      this.cert.file = file;
    },
    emitResetInput(value) {
      this.resetInput = false;
    },
    getSelected() {
      // this.cert = this.certSelect;
      if(this.certSelect !== undefined) {
        this.$store.commit('addCertificate', this.certSelect);
      }else {
        this.$store.commit('addCertificate', {});
      }

    },
    remove(item) {
      const index = this.select.indexOf(item);
      if (index >= 0) this.select.splice(index, 1);
    },
    selectItem(value) {},
    emitDadosForm() {
      if(this.certificate && this.certificate._id && !this.cert.file) {
        this.cert = this.certificate;
        this.$store.commit('addCertificate', {});
      }
      if (this.cert.file || this.cert._id) {
        let empIds = [];

        if (this.select != undefined && this.select.length > 0) {
          this.select.forEach(item => {
            empIds.push(item.empresa._id);
          });
          this.cert["empresa"] = empIds;
        } else {
          this.select != "" && this.select != undefined
            ? (this.cert["empresa"] = this.select.empresa._id)
            : "";
        }
        let obj = {};
        obj["dados"] = this.cert;
        obj["tipo"] = { component: "certificado" };
        obj.tipo["acao"] = this.edit == true ? "edit" : "create";
        this.cert = { file: undefined, password: "" };
        this.$emit("emitDadosForm", obj);
      } else {
        this.$emit("emitDadosForm", false);
      }
    }
  }
};
</script>
<style scoped>
.custom-file-upload i {
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/conta/empresa/certificado/formCertificado/FormCertificado.vue